import { render, staticRenderFns } from "./BookAppointment.vue?vue&type=template&id=04827341&scoped=true&"
import script from "./BookAppointment.vue?vue&type=script&lang=js&"
export * from "./BookAppointment.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointment.vue?vue&type=style&index=0&id=04827341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04827341",
  null
  
)

export default component.exports